export default __webpack_public_path__ + "static/media/teamDivider.5368cf96.svg";